var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinksection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2739E74C-42EB-492D-AD27-D107BB647E22") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CMS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Products---detail--add-section",
    transform: "translate(-1101.000000, -329.000000)",
    stroke: "#E10210",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(466.000000, 231.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(572.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    transform: "translate(64.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0149513,7.7649756 L20.5056183,2.27430868 C23.5380297,-0.758102913 28.4545402,-0.758102913 31.4869512,2.27430868 C34.519363,5.30672054 34.519363,10.2232303 31.4869512,13.255642 L25.9962853,18.7463091 M18.676202,26.0712256 L13.185535,31.5594757 C10.1427882,34.5263797 5.28024323,34.4959638 2.27484788,31.4912308 C-0.730547545,28.4864969 -0.762032278,23.6239591 2.2042016,20.580559 L7.69486847,15.0898924 M22.339868,11.4238081 L11.3585346,22.4051414",
    id: "Vector-20"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinksection);
export default __webpack_public_path__ + "static/media/Link section.4549294357b8407fe62632bc15384745.svg";
export { ForwardRef as ReactComponent };